<template>
  <div>
    <div class="stateBox">
      <!-- 审核中 -->
      <div class="stateBigBox" v-if="state == 4 || state == 2 || state == 20">
        <img src="../../assets/webImg/pending.png" alt="" />
        <h5>Gracias por elegir MasterSol</h5>
        <p style="padding:0 0.2rem">
          Hemos recibido su solicitud de préstamo. Estamos verificando las
          informaciones de su crédito historial. Por favor esperese con
          paciancia, te pondremos en contacto tras la App y SMS en unos minutos.
        </p>
      </div>
      <!-- 放款失败 -->
      <div class="stateBigBox" v-else-if="state == 6">
        <img src="../../assets/webImg/error.png" alt="" />
        <p style="width:7.42rem; margin-bottom:0.47rem">
          Lo sentimos, hay error en la transferencia de banco, la operación está
          fallada. Por favor, consulta con servicio al cliente relevante.
        </p>
        <div style="display:flex;justify-content:center">
          <div class="concat" style="margin-right: 1rem">
            <img src="../../assets/images/photoIcon.png" alt="" />
            <div>
              <h3>Número telefónico:</h3>
              <p @click="openApply('+51929659529', 1)">+51 929659529</p>
            </div>
          </div>
          <div class="concat">
            <img src="../../assets/images/whatsapp.png" alt="" />
            <div>
              <h3>WhatsApp:</h3>
              <p @click="openApply('+51960603592', 2)">+51 960603592</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 拒贷 -->
      <div class="stateBigBox" v-else-if="state == 3">
        <img src="../../assets/webImg/refuse.png" alt="" />
        <h5>
          Puede volver a solicitar en
          <span>{{ $setMoment(userInfo.reapply_time, 1, 1) }}</span>
        </h5>
        <p style="width:8rem">
          Lo sentimos, su solicitud no ha aprobado, actualmente su valor de
          crédito es insuficinete, por favor mantenga un buen historial
          crediticio.
        </p>
      </div>
      <!-- 放款中 -->
      <div class="stateBigBox" v-else-if="state == 12 || state == 5">
        <img src="../../assets/webImg/moneypending.png" alt="" />
        <p style="margin-bottom: 0.3rem;width: 6.52rem">
          Hay retraso bancario en el proceso del envío de dinero, le avisaremos
          por SMS cuando la transferencia sea exitosa.
        </p>
        <p style="width: 6.52rem">
          El depósito sería atrasado durante los días no laborales.
        </p>
      </div>
    </div>
    <!-- 首贷审核中状态展示 -->
    <div class="frLoanStatusBox" v-if="directPayoutSwitch == 1 &&state == 2 && userInfo.is_reloan == 0">
      <div class="frLoanStatusContent">
        Abra el canal rápido exclusivo. Una vez que la solicitud sea aprobada,
        el dinero se desembolsará automáticamente. No es necesario que confirme
        de nuevo el monto y el plazo, y no es necesario realizar operaciones
        manuales en todo el proceso. Por favor, confirme.
      </div>

      <div
        @click="confirmRepayBtn"
        class="confirmFrBtn"
        :style="{ opacity: directPayoutStatus ? 0.3 : 1 }"
      >
        {{ directPayoutStatus ? "Ha confirmado" : "Confirmar" }}
      </div>
    </div>

    <!-- 首贷审核中的弹窗 -->
    <van-overlay :show="frConfirmVisible">
      <div class="wrapper">
        <div class="frConfirmBox" @click.stop>
          <img
            class="titleImg"
            src="../../assets/images/frprogressImg.png"
            alt=""
          />
          <h3>¡Llegada del dinero a la velocidad del rayo!</h3>
          <p>
            Abra el canal rápido exclusivo. Una vez que la solicitud sea
            aprobada, el dinero se desembolsará automáticamente. No es necesario
            que confirme de nuevo el monto y el plazo, y no es necesario
            realizar operaciones manuales en todo el proceso. Por favor,
            confirme.
          </p>

          <div class="btnBox">
            <div class="closeBtn" @click="frConfirmVisible = false">
              Cerrar
            </div>
            <div class="subConfirmBtn" @click="confirmLoanBtn">Confirmar</div>
          </div>
        </div>
      </div>
    </van-overlay>

    <!-- 首贷审核中 - 确认直接放款弹窗 -->
    <van-overlay :show="confirmRepayVisible">
      <div class="wrapper">
        <div class="frConfirmBox confirmRepay" @click.stop>
          <h3>Confirmar</h3>
          <p>
            Por favor, confirme si permite el desembolso directo una vez
            aprobada la solicitud.
          </p>
          <div class="btnBox">
            <div class="closeBtn" @click="confirmRepayVisible = false">
              Cerrar
            </div>
            <div class="subConfirmBtn" @click="confirmLoanBtn">Confirmar</div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Header from "../../components/webComponents/header.vue";
import { getInfor, directPayout, getNewInfo } from "../../utils/api/h5page.js";
export default {
  name: "",
  components: {
    Header,
  },
  props: {},
  data() {
    return {
      state: "",
      userInfo: {},
      frConfirmVisible: false,
      confirmRepayVisible: false,
      directPayoutStatus: 0,
      directPayoutSwitch: 0,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    // 获取用户订单信息
    setUserData(data) {
      this.userInfo = data.loan_info;
      this.state = data.loan_info.order_status;
      // 首贷审核中状态展示信息
      this.directPayoutStatus = data.page_info.direct_payout_status;
      // 活动开关
      this.directPayoutSwitch = data.page_info.direct_payout_switch;
      if (
        data.page_info.direct_payout_switch == 1 &&
        data.page_info.direct_payout_pop_up == 1 &&
        data.loan_info.order_status == 2 &&
        data.loan_info.is_reloan == 0
      ) {
        this.frConfirmVisible = true;
      }
      localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
    },

    openApply(mobile, row) {
      if (row == 1) {
        window.location.href = "tel:" + mobile;
      } else {
        this.$Toast("Se está abriendo WhatsApp...");
        window.open("https://api.whatsapp.com/send?phone=" + mobile);
      }
    },

    // 确认贷款直接放款
    confirmLoanBtn() {
      directPayout().then((data) => {
        this.frConfirmVisible = false;
        this.confirmRepayVisible = false;
        this.$emit("getUserInformation");
      });
    },

    // 确认是否直接放款弹窗
    confirmRepayBtn() {
      if (this.directPayoutStatus) return;
      this.confirmRepayVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.stateBox {
  width: 12rem;
  background: linear-gradient(180deg, #ffffff 0%, #fff9f9 100%);
  border-radius: 0.2rem;
  padding: 0.14rem 0 0.51rem;
  margin: 0.18rem auto 0;
}
.stateBigBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  & > img {
    width: 3.9rem;
    margin-bottom: 0.7rem;
  }
  h5 {
    font-family: Roboto, Roboto;
    font-weight: 700;
    font-size: 0.28rem;
    color: #3a3a3a;
    margin-bottom: 0.3rem;
    width: 100%;
    text-align: center;
    span {
      color: #224c9e;
    }
  }
  p {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.23rem;
    color: #333333;
    text-align: center;
  }
  .concat {
    display: flex;
    img {
      display: block;
      width: 0.6rem;
      height: 0.6rem;
      margin-right: 0.2rem;
    }
    h3 {
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 0.22rem;
      color: #999999;
      margin-bottom: 0.06rem;
    }
    p {
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 0.24rem;
      color: #c90000;
      text-decoration-line: underline;
      text-align: left;
    }
  }
}

.frLoanStatusBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 12rem;
  height: 1.6rem;
  padding: 0 0.24rem 0 0.39rem;
  background: #fef6f0;
  border-radius: 0.2rem;
  margin: 0.2rem auto 0.37rem;
  .frLoanStatusContent {
    width: 7.63rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.23rem;
    color: #ab754c;
  }

  .confirmFrBtn {
    cursor: pointer;
    width: 2.23rem;
    height: 0.75rem;
    line-height: 0.75rem;
    background: #c90000;
    border-radius: 0.38rem;
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 0.28rem;
    color: #ffffff;
    text-align: center;
  }
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .frConfirmBox {
    position: relative;
    width: 5.4rem;
    height: 5.96rem;
    background: linear-gradient(180deg, #ffd6d6 0%, #ffffff 100%);
    border-radius: 0.6rem;
    border: 0.06rem solid rgba(0, 0, 0, 0.35);
    padding-top: 1.42rem;
    .titleImg {
      position: absolute;
      top: -1.65rem;
      left: 0;
      width: 100%;
    }
    h3 {
      width: 2.98rem;
      font-family: Roboto, Roboto;
      font-weight: 500;
      font-size: 0.27rem;
      color: #333333;
      margin: 0 auto 0.22rem;
      text-align: center;
    }
    p {
      width: 4.37rem;
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 0.22rem;
      color: #333333;
      text-align: center;
      margin: 0 auto 0.36rem;
      line-height: 0.28rem;
    }

    .btnBox {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      width: 4.7rem;
      margin: 0 auto;
      div {
        width: 2.2rem;
        height: 0.7rem;
        line-height: 0.7rem;
        background: linear-gradient(90deg, #f53333 0%, #ff4e99 100%);
        border-radius: 0.35rem;
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 0.28rem;
        color: #ffffff;
        text-align: center;
      }
      .closeBtn {
        cursor: pointer;
        background: #e8e8e8;
        color: #666666;
      }
    }
  }

  .confirmRepay {
    height: 3.7rem;
    padding-top: 0.4rem;
    h3 {
      font-family: Roboto, Roboto;
      font-weight: 700;
      font-size: 0.36rem;
      color: #333333;
      text-align: center;
    }

    p {
      width: 4.37rem;
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 0.24rem;
      color: #333333;
      margin: 0.27rem auto 0.49rem;
      text-align: center;
    }
  }
}
</style>
